import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const LeafIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 17 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.6019 17.5644C9.48507 19.7279 5.78272 18.8996 3.6631 18.1077C3.1549 19.1319 2.75094 20.2015 2.45692 21.3012C2.40715 21.5296 2.26548 21.7296 2.06308 21.8571C1.86068 21.9846 1.61413 22.0292 1.37767 21.9811C1.14121 21.9331 0.934209 21.7962 0.8022 21.6007C0.670192 21.4052 0.623992 21.1671 0.673765 20.9387C2.07671 15.9918 5.02771 11.5843 9.1231 8.31925C5.49762 9.98507 2.59923 12.8361 0.940996 16.3677C-0.650239 13.2938 -0.674533 7.60357 4.47572 4.91683C6.65 3.79051 8.84858 3.5676 11.5087 2.68766C12.9283 2.20087 14.1554 1.29861 15.0192 0.106518C15.0418 0.0702591 15.0749 0.0410744 15.1143 0.022453C15.1536 0.00383161 15.1978 -0.00343873 15.2413 0.00151092C15.2849 0.00646057 15.326 0.023421 15.3599 0.0503647C15.3937 0.0773084 15.4188 0.113096 15.4322 0.153449C16.2824 2.37089 19.6957 12.6368 12.6019 17.5644Z"
        fill="currentColor"
      />
    </svg>
  )
})

LeafIcon.displayName = 'LeafIcon'
